
import React from 'react';
import { Card, CardHeader, CardContent, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { Tag } from 'lucide-react';

export const TariffInfoLoading = () => (
  <Card className="w-full bg-card/80 shadow-md">
    <CardHeader>
      <CardTitle className="text-lg flex items-center gap-2">
        <Tag className="h-5 w-5" /> 
        Загрузка тарифа...
      </CardTitle>
    </CardHeader>
    <CardContent>
      <div className="space-y-3">
        <Skeleton className="h-4 w-3/4" />
        <Skeleton className="h-4 w-1/2" />
        <Skeleton className="h-4 w-2/3" />
      </div>
    </CardContent>
  </Card>
);
